export enum TransactionStatusEnum {
    Prepared = 'PREPARED',
    Init = 'INIT',
    Timeout = 'TIMEOUT',
    Cancelled = 'CANCELLED',
    NotAuthorized = 'NOTAUTHORIZED',
    InPayment = 'INPAYMENT',
    InFraud = 'INFRAUD',
    Authorized = 'AUTHORIZED',
    Fraud = 'FRAUD',
    Reversed = 'REVERSED',
    Finished = 'FINISHED',
}
